import { Component, signal } from '@angular/core';
import { provideHeadingLevel } from '@storyteller/core';

// feature component
@Component({
    selector: 'story-feature',
    template: `
        <div class="flex flex-col gap-1">
            <div class="flex-none pb-3 empty:hidden">
                <!-- <ng-container *ngTemplateOutlet="image.template"></ng-container> -->
                <ng-content select="story-image"></ng-content>
            </div>

            <!-- <div class="flex-none pb-4">
                    <ng-container *ngTemplateOutlet="icon.template"></ng-container>
                </div> -->
            <div class="flex-none pb-[18px] pt-[6px] empty:hidden" aria-hidden="true">
                <ng-content select="story-icon"></ng-content>
                <ng-content select="aui-icon"></ng-content>
            </div>

            <ng-content select="story-title"></ng-content>
            <!-- <story-title [headingLevel]="headingLevel()">
                    <ng-container *ngTemplateOutlet="title.template"></ng-container>
                </story-title> -->

            <ng-content select="story-description"></ng-content>
            <!-- <story-description>
                    <ng-container *ngTemplateOutlet="description.template"></ng-container>
                </story-description> -->
        </div>

        <ng-content></ng-content>
    `,
    providers: [provideHeadingLevel(signal(3), true)],
})
export class StoryFeatureComponent {}
